import { monthCloseOutAlertConstants } from '../../actions/constant';

const {
  GET_MONTH_CLOSE_OUT_ALERT_REQUEST,
  GET_MONTH_CLOSE_OUT_ALERT_SUCCESS,
  GET_MONTH_CLOSE_OUT_ALERT_FAILURE,
  GET_MONTH_CLOSE_OUT_ALERT_RESET,
  GET_MONTH_CLOSE_OUT_ALERT_LOADING,
} = monthCloseOutAlertConstants;
const intitialstate: object = {
  response: null,
  getStatus: false,
  loading: false,
};

export const monthlyCloseOutAlertReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case GET_MONTH_CLOSE_OUT_ALERT_SUCCESS: {
      return {
        ...state,
        getStatus: true,
        response: action.payload,
        loading: false,
      };
    }

    case GET_MONTH_CLOSE_OUT_ALERT_FAILURE:
      return {
        ...state,
        getStatus: false,
        response: action.payload,
        loading: false,
      };

    case GET_MONTH_CLOSE_OUT_ALERT_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_MONTH_CLOSE_OUT_ALERT_RESET:
      return intitialstate;

    default:
      return state;
  }
};
